import { CloseButton, Dialog, Icon, Stack, Text } from "@chakra-ui/react";
import { CheckIcon, XIcon } from "@phosphor-icons/react/dist/ssr";

const ModalStatus = ({ isOpen, onClose, type, title, message }) => {
    return (
        <Dialog.Root open={isOpen} onOpenChange={() => onClose()} size="sm" placement="top">
            <Dialog.Backdrop />
            <Dialog.Positioner top="100px" overflow="visible">
                <Dialog.Content height="200px">
                    <Dialog.Header />
                    <Dialog.CloseTrigger asChild>
                        <CloseButton
                            bg="#D8D8D8"
                            color="#5F5F5F"
                            rounded="full"
                            top="-1rem"
                            right="-1rem"
                            p={2}
                        />
                    </Dialog.CloseTrigger>
                    <Dialog.Body p={4}>
                        <Stack alignItems="center">
                            {type === "success" ? (
                                <Icon color="green.600" boxSize="50px">
                                    <CheckIcon weight="bold" />
                                </Icon>
                            ) : (
                                <Icon color="red.600" boxSize="50px">
                                    <XIcon weight="bold" />
                                </Icon>
                            )}
                        </Stack>
                        <Stack my={6} alignItems="center" textAlign="center" color="black">
                            <Text fontWeight={500} fontSize="md">
                                {message}
                            </Text>
                        </Stack>
                        <Stack my={6} alignItems="center" textAlign="center" color="black">
                            <Text fontWeight={700} fontSize="md">
                                {title}
                            </Text>
                        </Stack>
                    </Dialog.Body>
                    <Dialog.Footer></Dialog.Footer>
                </Dialog.Content>
            </Dialog.Positioner>
        </Dialog.Root>
    );
};

export default ModalStatus;
